import {
  Invoice,
  InvoiceRow,
  InvoiceStatus,
  PayeeReviewStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorInvoicePermissions = ({
  invoice,
  accountId
}: {
  invoice: Invoice | InvoiceRow;
  accountId?: string;
}) => {
  // Search rows project creator provenance into metadata; details expose actors.
  const createdBy =
    ("actors" in invoice ? invoice.actors?.createdBy : undefined) ??
    invoice.metadata?.createdBy;
  const isPayee = !!accountId && invoice.payeeAccountId === accountId;
  const isCreator = isPayee && createdBy === accountId;
  const isRecipient =
    isPayee &&
    !!createdBy &&
    createdBy === invoice.payerAccountId &&
    createdBy !== accountId;
  const isReviewable =
    isRecipient &&
    !!invoice.status &&
    [
      InvoiceStatus.OPENED,
      InvoiceStatus.OVERDUE,
      InvoiceStatus.PENDING
    ].includes(invoice.status);

  return {
    isCreator,
    isRecipient,
    isReviewable,
    canAccept:
      isReviewable && invoice.payeeReviewStatus !== PayeeReviewStatus.ACCEPTED,
    canDispute:
      isReviewable && invoice.payeeReviewStatus !== PayeeReviewStatus.DISPUTED
  };
};
